import { maxHeight } from '@mui/system';
import { theme } from 'bs-unified-ui';
import { COLORS } from '~/themes/common';

const style = {
  quillContainer: {
    'position': 'relative',
    '& .ql-toolbar': {
      borderRadius: '5px 5px 0 0',
      border: '0.25px solid',
      paddingTop: 6,
      paddingBottom: 6,
    },
    '& .ql-toolbar.ql-snow': {
      padding: 4,
      borderColor: theme.background.outlineDivider,
      display: 'flex',
      flexWrap: 'wrap',
      gap: 4,
    },
    '& .ql-import': {
      height: 'unset',
      width: 'unset !important',
      marginTop: -4,
    },
    '& .ql-container': {
      borderRadius: '0 0 5px 5px',
      backgroundColor: theme.background.white,
      borderColor: `${theme.background.outlineDivider} !important`,
      border: '0.25px solid',
    },
    '& .ql-editor': {
      'minHeight': 120,
      'maxHeight': 150,
      'fontSize': 14,
      'fontFamily': '"Lato", sans-serif',
      '&::-webkit-scrollbar': {
        width: 5,
        height: 5,
      },
      '&::-webkit-scrollbar-track': {
        borderRadius: 10,
        backgroundColor: 'transparent',
      },
      '&::-webkit-scrollbar-thumb': {
        borderRadius: 10,
        backgroundColor: '#b4bfd9',
      },
    },
    '& .ql-tooltip': {
      zIndex: 999999,
      left: '50% !important',
      transform: 'translateX(-100%) !important',
      top: '-40px !important',
      bottom: 'auto !important',
      position: 'absolute !important',
      marginLeft: '-8px !important',
    },
    '& .ql-tooltip.ql-flip': {
      top: 'auto !important',
      bottom: '-40px !important',
    },
  },
  error: {
    '& .ql-toolbar': {
      borderColor: '#F24822 !important',
      borderWidth: '1.5px',
    },
    '& .ql-container': {
      borderColor: '#F24822 !important',
      borderWidth: '1.5px',
    },
  },
  disabled: {
    'userSelect': 'none',
    'pointerEvents': 'none',
    'cursor': 'not-allowed',
    '& .ql-toolbar': {
      borderColor: COLORS.gray.disableGray,
      borderBottom: 'none',
    },
    '& .ql-container': {
      borderColor: COLORS.gray.disableGray,
      backgroundColor: COLORS.gray.disableGray2,
    },
  },
  switchContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginBottom: 8,
    position: 'absolute',
    right: 0,
    top: -30,
  },
  formLabel: {
    textAlign: 'left',
    fontSize: 14,
    letterSpacing: 0,
    color: theme.foreground.black,
    opacity: 1,
    padding: '4px 0 0 0',
  },
  textArea: {
    'fontFamily': '"Lato", sans-serif',
    'flex': 1,
    'minHeight': 140,
    'width': 'calc(100% - 28px)',
    'resize': 'none',
    'backgroundColor': theme.background.white,
    'padding': '10px 14px',
    'fontSize': 14,
    'marginRight': 10,
    'borderRadius': 5,
    'border': `0.25px solid ${theme.background.outlineDivider}`,
    '&:focus': {
      outline: 'none',
    },
    '&::placeholder': {
      fontFamily: '"Lato", sans-serif',
      color: COLORS.gray.textGray2,
      fontWeight: 300,
    },
    '&::-webkit-scrollbar': {
      width: 5,
      height: 5,
    },
    '&::-webkit-scrollbar-track': {
      borderRadius: 10,
      backgroundColor: 'transparent',
    },
    '&::-webkit-scrollbar-thumb': {
      borderRadius: 10,
      backgroundColor: '#b4bfd9',
    },
  },
};

export default style;
